import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { selectFormSubmissionById } from '@client/content/redux/forms/redux';

export const useFormSubmission = (formId: string): RemoteRecord<any> => useSelector(
  (state: AppState) => selectFormSubmissionById(state, formId),
);
